import { useState } from 'react';
import { Layout } from '@/components/layout/Layout';
import { EmailConnectionCard } from '@/components/eirsaliye/EmailConnectionCard';
import { EirsaliyeSyncBar } from '@/components/eirsaliye/EirsaliyeSyncBar';
import { EirsaliyeStatsCards } from '@/components/eirsaliye/EirsaliyeStatsCards';
import { EirsaliyeDailyView } from '@/components/eirsaliye/EirsaliyeDailyView';
import { EirsaliyeTable } from '@/components/eirsaliye/EirsaliyeTable';
import { SyncLogSection } from '@/components/eirsaliye/SyncLogSection';
import { useEirsaliyes } from '@/hooks/use-eirsaliye';
import { FileText } from 'lucide-react';

const PAGE_SIZE = 10;

const EIrsaliye = () => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);

  const { data: result, isLoading, refetch } = useEirsaliyes({
    page,
    pageSize: PAGE_SIZE,
    search: search || undefined,
  });

  return (
    <Layout>
      <div className="p-6 space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <FileText className="w-8 h-8 text-blue-500" />
            Email e-Irsaliye
          </h1>
          <p className="text-muted-foreground">
            Email uzerinden gelen e-Irsaliye belgelerini otomatik olarak icerir ve isler.
          </p>
        </div>

        {/* Email Connection */}
        <EmailConnectionCard />

        {/* Sync Bar */}
        <EirsaliyeSyncBar
          search={search}
          onSearchChange={(val) => { setSearch(val); setPage(0); }}
          onRefresh={() => refetch()}
        />

        {/* Stats */}
        <EirsaliyeStatsCards />

        {/* Daily View */}
        <EirsaliyeDailyView />

        {/* Table */}
        <EirsaliyeTable
          data={result?.data || []}
          count={result?.count || 0}
          page={page}
          pageSize={PAGE_SIZE}
          isLoading={isLoading}
          onPageChange={setPage}
        />

        {/* Sync Logs */}
        <SyncLogSection />
      </div>
    </Layout>
  );
};

export default EIrsaliye;
